import React from 'react'
import styles from './style.css'
import queryString from 'query-string'
import { useLocation, withRouter } from 'react-router-dom'
import { useStore } from '../../../StateProvider'

const Logo = () => {
  const location = useLocation()
  const { iframe = '' } = queryString.parse(location.search)
  const iframeStyle = iframe === 'true' ? styles.center : ''
  const [{ whitelabel }] = useStore()
  const { logo, whiteLabelName, whiteLabelURL, mimeType, logoLinkDisabled } = whitelabel

  if (logoLinkDisabled) {
    return (
      <div className={`${styles.headerLogo} ${iframeStyle}`}>
        {logo && mimeType && (
          <span className={styles.logoLink}>
            <img className={styles.logo} src={`${mimeType},${logo}`} alt={whiteLabelName} />
          </span>
        )}
      </div>
    )
  }

  return (
    <div className={`${styles.headerLogo} ${iframeStyle}`}>
      {logo && mimeType && (
        <a
          className={styles.logoLink}
          href={whiteLabelURL}
          rel='noopener noreferrer'
          target='_blank'
        >
          <img className={styles.logo} src={`${mimeType},${logo}`} alt={whiteLabelName} />
        </a>
      )}
    </div>
  )
}

export default withRouter(Logo)
